import { Oval } from "react-loader-spinner";
import React, { useState, useEffect } from "react";
import {
  Col,
  Modal,
  Row,
  Spinner,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Input, Label } from "reactstrap";
import {
  getArtByUserIdRequest,
  getPrinterList,
  postArtRequest,
  uploadArt,
} from "store/actions";
import toastr from "toastr";
import heic2any from "heic2any";
import Tiff from "tiff.js";
import { useLocation, useNavigate } from "react-router-dom";
export default function Art(props) {
  const [pagename, setPageName] = useState();

  const pageType = props.data ? props.data : "artSubmission";
  const dispatch = useDispatch();
  const [tabs, settabs] = useState("approved");
  const [upArt, setAploadArt] = useState(false);
  const [isArt, setisArt] = useState(true);
  const [fields, setFields] = useState("");
  const [imageURLS, setImageURLs] = useState();
  const selector = useSelector((state) => state);
  const [images, setimages] = useState([]);
  const ArtsByUserId = useSelector((selector) => selector?.art?.ArtsByUserId);
  const { loading } = useSelector((state) => state?.art);
  const [approveArt, setApproveArt] = useState([]);
  const [pendingArt, setPendingArt] = useState([]);
  const [rejectedArt, setRejectedArt] = useState([]);
  const id = useSelector((selector) => selector?.Login?.user?._id);
  const [disableSubmitButton, setDisableSubmitButton] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [previewLoading, setPreviewLoading] = useState(false);
  const { Printers } = useSelector((state) => state?.Print);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location && location?.state) {
      settabs(location?.state);
    } else {
      settabs("approved");
    }
  }, [location, pagename]);
  useEffect(() => {
    setPageName(props.data ? props.data : "artSubmission");
    setSearch("");
  }, [props]);
  function deleteFile(e) {
    setAploadArt(true);
    setImageURLs();
    setimages([]);
  }

  const callback2 = (response) => {
    console.log("Raw artwork data:", response.data);

    const artworksWithPrinterData = response.data.filter(
      (item) => item.artInfo?.printer_id
    );
    console.log("Artworks with printer data:", artworksWithPrinterData);

    // Check specifically for artworks that meet physical artwork criteria
    const physicalEligibleArtworks = response.data.filter(
      (item) =>
        item.adminStatus === "Approved" &&
        item.status === true &&
        item.artInfo?.printer_id &&
        // item.artInfo.printer_id !== "" &&
        // item.artInfo.printer_id !== null &&
        item.artInfo?.printer_status === "Approved"
    );

    console.log("Physical eligible artworks:", physicalEligibleArtworks);
    console.log("Count:", physicalEligibleArtworks.length);

    // Let's also check what printer_status values exist
    const printerStatusCounts = {};
    artworksWithPrinterData.forEach((item) => {
      const status = item.artInfo?.printer_status || "missing";
      printerStatusCounts[status] = (printerStatusCounts[status] || 0) + 1;
    });
    console.log("Printer status distribution:", printerStatusCounts);
    let pageType = props.data ? props.data : "artSubmission";
    const { status } = response;
    if (status === "success") {
      let approve_art = [];
      approve_art.push(response.data);

      const categorizedData = {
        approved: [],
        pending: [],
        rejected: [],
      };
      approve_art[0].forEach((item) => {
        if (!item.type) {
          item.type = "artSubmission";
        }
        if (item.type === "artSubmission" && pageType === "artSubmission") {
          if (item.adminStatus === "Approved" && item.status === true) {
            categorizedData.approved.push(item);
          } else if (item.adminStatus === "Pending") {
            categorizedData.pending.push(item);
          } else if (item.adminStatus === "Rejected") {
            categorizedData.rejected.push(item);
          }
        } else if (
          item.type === "artworkproofing" &&
          pageType === "artworkproofing"
        ) {
          // CHANGED: Check both adminStatus AND printer_status
          if (
              item.adminStatus === "Approved" &&
              // item.physical_print === true &&
              item.status === true && //add by ankit
              item.artInfo?.printer_id && //add by ankit
              item.artInfo?.printer_status === "Approved"
          ) {
            categorizedData.approved.push(item);
          } else if (
            item.adminStatus === "Rejected" ||
            item?.artInfo?.printer_status === "Rejected"
          ) {
            categorizedData.rejected.push(item);
          } else {
            categorizedData.pending.push(item);
          }
        }
      });
      setApproveArt(categorizedData.approved);
      setPendingArt(categorizedData.pending);
      setRejectedArt(categorizedData.rejected);
    } else {
    }
  };
  
  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {props}
    </Tooltip>
  );

  useEffect(() => {
    if (id && pagename) {
      dispatch(getArtByUserIdRequest(id, callback2));
    }
  }, [id, pagename]);

  const uploadArts = () => {
    const dataToSend = {
      pagename: pagename,
    };
    navigate(`uploadArt?pagename=${pagename}`,{ replace: true });

  };

  const closedialogBox = () => {
    setAploadArt(false);
    setImageURLs();
    setimages([]);
  };
  const [fileData, setFileData] = useState();

  const uploadMultiFileSuccess = (name) => async (response) => {
    const date = new Date();
    const timeStamp = date.getTime();
    let imageData = {};
    imageData.images = response.data._doc._id;
    imageData.user_id = selector?.Login?.user?._id;
    imageData.fileData = fileData;
    imageData.hash = response.data.hash;
    imageData.publicUrl = response.data.publicUrl;
    dispatch(postArtRequest(imageData, callback));
  };
  const [isHeic, setIsHeic] = useState();

  const onChangeHandlerImage = (name) => async (e) => {
    setPreviewLoading(true);
    let images = e.target.files;
    if (images.length < 1) return;
    for (let i = 0; i < images.length; i++) {
      const ext = images[i].name.split(".").pop().toLowerCase();
      if (
        ext !== "png" &&
        ext !== "jpg" &&
        ext !== "jpeg" &&
        ext !== "tiff" &&
        ext !== "heic"
      ) {
        toastr.error(
          "Invalid file format. Please upload a JPG, JPEG, HEIC, Tiff & PNG image."
        );
        return;
      }
      for (let i = 0; i < images.length; i++) {
        if (images[i] && images[i].size >= 50 * 1e7) {
          toastr.error(
            "File size exceeds the limit. Please choose a smaller image."
          );
          return false;
        }
      }

      if (ext === "heic") {
        setIsHeic(true);
        const blobfile = e.target.files[0];
        const blobURL = URL.createObjectURL(blobfile);
        const name = e.target.files[0].name.replace(/\s/g, "").split(".")[0];

        // Convert HEIC to JPEG
        const resultBlob = await heic2any({
          blob: await (await fetch(blobURL)).blob(),
          toType: "image/jpg",
          quality: 1,
        });

        // Create a new JPEG file from the converted blob
        const converted_file = new File([resultBlob], name + ".jpg", {
          type: "image/jpeg",
          lastModified: new Date().getTime(),
        });

        // Read the converted file as a data URL and update state
        const reader = new FileReader();
        reader.readAsDataURL(converted_file);

        reader.onload = (e) => {
          setImageURLs(e.target.result);
          setimages((prevImages) => prevImages.concat(converted_file));
        };
      } else if (ext === "tiff") {
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onload = () => {
          const tiff = new Tiff({ buffer: reader.result });
          const canvas = tiff.toCanvas();
          const ctx = canvas.getContext("2d");
          let firstname = e.target.files[0].name.replace(/\s/g, "");
          let removed_tiff = firstname.split(".")[0];
          let name = removed_tiff;
          const newCanvas = document.createElement("canvas");
          const newCtx = newCanvas.getContext("2d");
          newCanvas.width = canvas.width;
          newCanvas.height = canvas.height;
          newCtx.drawImage(canvas, 0, 0);
          const jpgData = newCanvas.toDataURL("image/jpeg");
          setImageURLs(jpgData);
          canvas.toBlob(
            (blob) => {
              const downloadLink = document.createElement("a");
              downloadLink.href = URL.createObjectURL(blob);
              downloadLink.download = "converted.jpg";
              let converted_file = new File([blob], name + ".jpeg", {
                type: "image/jpeg",
                lastModified: new Date().getTime(),
              });
              // downloadLink.click();
              setimages((prevImages) => prevImages.concat(converted_file));
            },
            "image/jpeg",
            1
          );
        };
        reader.readAsArrayBuffer(file);
      } else {
        setimages((prevImages) => prevImages.concat(images[0]));
        const fileArray = Array.from(images).map((file) =>
          URL.createObjectURL(file)
        );
        setImageURLs(fileArray);
      }
    }
    setPreviewLoading(false);
  };
  const callback = (response) => {
    const { status } = response;
    if (status === "success") {
      dispatch(getArtByUserIdRequest(id, callback2));
      toastr.success("Your art has been submitted for approval successfully");
      setimages([]);
      settabs("pending");
      // ArtistTabs("pending")
    } else {
      toastr.error("Something went wrong");
    }
    setDisableSubmitButton(false);
    setLoading2(false);
  };
  const onSubmit = async (evt) => {
    evt.preventDefault();
    setLoading2(true);
    if (images.length < 1) {
      toastr.error("No image selected. Please choose an image to upload.");
      setLoading2(false);
      return;
    }
    closedialogBox();
    setDisableSubmitButton(true);
    var formData = new FormData();
    const art = "art";
    formData.append("category", art);
    let lastimage = {};
    if (setIsHeic) {
      for (const key of Object.keys(images)) {
        lastimage = images[key];
      }
    } else {
      for (const x of images) {
        for (const key of Object.keys(images)) {
          lastimage = x[key];
        }
      }
    }
    formData.append("image", lastimage);
    dispatch(uploadArt(formData, uploadMultiFileSuccess("images")));
  };
  function setArtData(status) {
    const filteredData = ArtsByUserId.filter((item) => {
      if (item.type !== pageType) return false; // Filter by type first

      if (pageType === "artSubmission") {
        switch (status) {
          case "approved":
            return item.adminStatus === "Approved" && item.status;
          case "pending":
            return item.adminStatus === "Pending";
          case "rejected":
            return item.adminStatus === "Rejected";
          default:
            return false;
        }
      } else {
        switch (status) {
          case "approved":
            return (
              item.adminStatus === "Approved" &&
              item.status === true &&       //add by ankit         // IMPORTANT
              item.artInfo?.printer_id &&   //addby ankit              // printer assigned
              item.artInfo?.printer_status === "Approved" // printer approved
            );
          case "pending":
            return (
              item.adminStatus === "Pending" ||
              item?.artInfo?.printer_status === "Pending"
            );
          case "rejected":
           return (
              item.adminStatus === "Rejected" ||
              item?.artInfo?.printer_status === "Rejected"
            );
          default:
            return false;
        }
      }
    });

    switch (status) {
      case "approved":
        setApproveArt(filteredData);
        break;
      case "pending":
        setPendingArt(filteredData);
        break;
      case "rejected":
        setRejectedArt(filteredData);
        break;
      default:
        setApproveArt(filteredData); // Default to approved if no valid status
    }
  }

  const ArtistTabs = async (data) => {
    settabs(data);
    setArtData(data);
  };
  useEffect(() => {
    console.log("fajdsklfjaskldjfklajsdkf", tabs);
  }, [tabs]);

  // useEffect(() => { ArtistTabs("approved")

  // }, [pagename])

  const displayText = (item) => {
    return item?.artInfo
      ? item.artInfo.title.length > 20
        ? item.artInfo.title.substring(0, 20) + "..."
        : item.artInfo.title
      : item?.images?.file_name.split(".")[0].length > 20
      ? item.images.file_name.split(".")[0].substring(0, 20) + "..."
      : item.images.file_name.split(".")[0];
  };

  const tooltipText = (item) => {
    return item?.artInfo
      ? item.artInfo.title
      : item?.images?.file_name.split(".")[0];
  };

  useEffect(() => {
    setApproveArt([]);
    setPendingArt([]);
    setRejectedArt([]);
  }, [pageType]);

  return (
    <>
      {(loading || loading2 || previewLoading) && (
        <div className="loaderBoxMiane" style={{ zIndex: 10000 }}>
          <Oval
            height={80}
            width={80}
            color="#6C63FF"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            ariaLabel="oval-loading"
            secondaryColor="#6C63FF"
            strokeWidth={2}
            strokeWidthSecondary={2}
          />
        </div>
      )}

      <Modal
        className="EmailVerifyBoxModel uploadimg text-center"
        show={upArt}
        centered
        animation={false}
      >
        <div className="dialogHeader px-3 pt-3">
          <h3>Upload Art </h3>
          <button onClick={closedialogBox}>
            <i className="fa-regular fa-xmark"></i>
          </button>
        </div>
        <div className="overflowUploadbOx px-3">
          {!!imageURLS ? (
            <div className="upoadedImage">
              <div className="uploadedArt">
                <div className="image">
                  <img src={imageURLS} alt="Art" />
                  <button onClick={() => deleteFile(imageURLS)}>
                    <i className="fa-sharp fa-light fa-circle-xmark"></i>
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className="uploadBox">
              <Label htmlFor="uploadartNew">
                {fields?.imagePreview ? (
                  <img src={fields?.imagePreview} width={50} alt="" />
                ) : (
                  <img
                    src="../../images/svg/uploadIcon.svg"
                    width={50}
                    alt=""
                  />
                )}
                <p>UPLOAD FROM YOUR DEVICE</p>
                <p className="text-black">
                  File size must not exceed [500] MB.
                </p>
                {loading ? (
                  <Spinner
                    animation="border"
                    size="xxl"
                    role="status"
                  ></Spinner>
                ) : (
                  ""
                )}
                <p className="fileNote">
                  Please upload a valid image file (e.g., JPG, JPEG, HEIC &
                  PNG).
                </p>
              </Label>
              <Input
                type="file"
                id="uploadartNew"
                accept="image/*"
                onChange={onChangeHandlerImage("image")}
              />
            </div>
          )}
        </div>
        <div className="text-end mt-4 px-3 pb-3">
          <button
            type="button"
            className="btn btn-outline-secondary  fw-semibold px-5"
            onClick={closedialogBox}
          >
            Cancel
          </button>
          <button
            className="btn btn-secondary text-white fw-semibold px-5 ms-3"
            onClick={onSubmit}
            disabled={disableSubmitButton}
          >
            Submit
          </button>
        </div>
      </Modal>
      <Row>
        <Col lg={12} className="mb-4">
          <div className="d-flex w-100 align-items-center justify-content-between flex-wrap">
            <h1 className="mb-0">
              {pagename === "artworkproofing"
                ? "Physical Artwork Proofing"
                : "Art"}
            </h1>
          </div>
        </Col>
        <Col lg={12}>
          <div className="artTab mb-4">
            <ul>
              <li
                onClick={() => ArtistTabs("approved")}
                className={tabs === "approved" ? "active" : ""}
              >
                Approved
              </li>
              <li
                onClick={() => ArtistTabs("pending")}
                className={tabs === "pending" ? "active" : ""}
              >
                Pending
              </li>
              <li
                onClick={() => ArtistTabs("rejected")}
                className={tabs === "rejected" ? "active" : ""}
              >
                Rejected
              </li>
            </ul>
          </div>

          {isArt === true ? (
            <>
              <Row>
                <Col lg={6}>
                  <div className="position-relative">
                    <Input
                      placeholder="Search"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      type="text"
                      className="searchInput form-control"
                    />
                    <button className="btn position-absolute end-0 top-0 bottom-0 my-auto border-0">
                      <i className="fa-light fa-magnifying-glass"></i>
                    </button>
                  </div>
                </Col>
                <Col className="ms-auto mt-auto" lg={2}>
                  <div className="d-flex align-items-center justify-content-end gap-3">
                    <div className="uploadIcon">
                      <Label className="mb-0" onClick={uploadArts}>
                        <i className="fa-regular fa-file-arrow-up"></i>
                      </Label>
                    </div>
                    <h5 className="mb-0 fw-semibold">Upload Art</h5>
                  </div>
                </Col>
              </Row>
              <Row className="mt-4">
                {tabs === "approved" &&
                  approveArt.length > 0 &&
                  approveArt
                    .filter((item2) => {
                      return search.toLowerCase() === ""
                        ? item2
                        : item2.images.file_name
                            .toLowerCase()
                            .includes(search.toLowerCase()) ||
                            item2?.artInfo?.title
                              .toLowerCase()
                              .includes(search.toLowerCase());
                    })
                    .map((item, index) => (
                      <Col
                        key={index}
                        className="mb-3"
                        xs={12}
                        sm={6}
                        md={4}
                        lg={3}
                      >
                        <div className="artbox">
                          <figur>
                            <img src={item?.images?.link} alt="Art" />
                            <figcaption>
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip id="tooltip">
                                    {tooltipText(item)}
                                  </Tooltip>
                                }
                              >
                                <span>{displayText(item)}</span>
                              </OverlayTrigger>{" "}
                            </figcaption>
                          </figur>
                        </div>
                      </Col>
                    ))}
                {tabs === "approved" && approveArt.length <= 0 && (
                  <div className="text-center d-grid justify-content-center py-5">
                    <img
                      src={"../../images/svg/mpdatanft.svg"}
                      alt="Create collection"
                    />
                    <h3>No Approved Arts</h3>
                  </div>
                )}

                {tabs === "pending" &&
                  pendingArt.length > 0 &&
                  pendingArt
                    .filter((item2) => {
                      return search.toLowerCase() === ""
                        ? item2
                        : item2.images.file_name
                            .toLowerCase()
                            .includes(search.toLowerCase()) ||
                            item2?.artInfo?.title
                              .toLowerCase()
                              .includes(search.toLowerCase());
                    })
                    .map((item, index) => (
                      <Col
                        key={index}
                        className="mb-3"
                        xs={12}
                        sm={6}
                        md={4}
                        lg={3}
                      >
                        <div className="artbox">
                          <figur>
                            <img src={item?.images?.link} alt="Art" />
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="tooltip">
                                  {tooltipText(item)}
                                </Tooltip>
                              }
                            >
                              <figcaption>{displayText(item)}</figcaption>
                            </OverlayTrigger>
                          </figur>
                        </div>
                      </Col>
                    ))}
                {tabs === "pending" && pendingArt.length <= 0 && (
                  <div className="text-center d-grid justify-content-center py-5">
                    <img
                      src={"../../images/svg/mpdatanft.svg"}
                      alt="Create collection"
                    />
                    <h3>No Pending Arts</h3>
                  </div>
                )}

                {tabs === "rejected" &&
                  rejectedArt.length > 0 &&
                  rejectedArt
                    .filter((item2) => {
                      return search.toLowerCase() === ""
                        ? item2
                        : item2.images.file_name
                            .toLowerCase()
                            .includes(search.toLowerCase()) ||
                            item2?.artInfo?.title
                              .toLowerCase()
                              .includes(search.toLowerCase());
                    })
                    .map((item, index) => (
                      <Col
                        key={index}
                        className="mb-3"
                        xs={12}
                        sm={6}
                        md={4}
                        lg={3}
                      >
                        <div className="artbox">
                          <figur>
                            <img src={item?.images?.link} alt="Art" />
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="tooltip">
                                  {tooltipText(item)}
                                </Tooltip>
                              }
                            >
                              <figcaption>{displayText(item)}</figcaption>
                            </OverlayTrigger>
                          </figur>
                        </div>
                      </Col>
                    ))}
                {tabs === "rejected" && rejectedArt.length <= 0 && (
                  <div className="text-center d-grid justify-content-center py-5">
                    <img
                      src={"../../images/svg/mpdatanft.svg"}
                      alt="Create collection"
                    />
                    <h3>No Rejected Arts</h3>
                  </div>
                )}
              </Row>
            </>
          ) : (
            <div className="text-center d-grid justify-content-center py-5">
              <img
                src={"../../images/svg/mpdatanft.svg"}
                alt="Create collection"
              />
              <button onClick={uploadArts} className="btn btn-primary mt-4">
                Upload Art
              </button>
            </div>
          )}
        </Col>
      </Row>
      {loading ? (
        <Spinner animation="border" size="sm" role="status"></Spinner>
      ) : (
        ""
      )}
    </>
  );
}
